module.exports = __webpack_public_path__ + "static/media/8.f88ab5d0.jpg";